
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import { sharedState } from '../../../../framework/state';

import { CustomerReportVehicleTypeRow } from '../../../../../common/application/model/report/CustomerReportVehicleTypeRow';
import { constructMonthsFromNowString } from '../../../../../common/application/service/query_helper_service';

@Component
export default class VehicleTypeTable extends Vue {
    @Prop(Array) readonly rows!: CustomerReportVehicleTypeRow[];

    shared = sharedState;

    local = {
        totalVehicles: 0,
        totalEnding: 0,
        totalOrders: 0,
    };

    mounted() {
        this.initValues();
    }

    @Watch('rows')
    rowsChanged() {
        this.initValues();
    }

    get endingContracts(): string {
        try {
            const monthsFromNow = constructMonthsFromNowString(6);

            return `/#/vehicle-contract?page=1&smartFleetContractEnd=${monthsFromNow}&query=smartFleetContractEnd%3C%7BsmartFleetContractEnd%7D`;
        } catch (error) {
            console.error('Error setting link dynamically', error);
            return `/#/vehicle-contract?page=1`;
        }
    }

    private initValues() {
        this.local.totalEnding = 0;
        this.local.totalVehicles = 0;
        this.local.totalOrders = 0;
        this.local.totalEnding = this.totalEnding;
        this.local.totalOrders = this.totalOrders;
        this.local.totalVehicles = this.totalVehicles;
    }

    private get totalVehicles(): number {
        let total = 0;

        if (!this.rows.length) {
            return total;
        }

        for (const row of this.rows) {
            total += row.active;
        }

        return total;
    }

    private get totalOrders(): number {
        let total = 0;

        if (!this.rows.length) {
            return total;
        }

        for (const row of this.rows) {
            total += row.acquisition;
        }

        return total;
    }

    private get totalEnding(): number {
        let total = 0;

        if (!this.rows.length) {
            return total;
        }

        for (const row of this.rows) {
            total += row.ending;
        }

        return total;
    }
}
